const initTabMenu = () => 
{
  const tabBotao = document.querySelectorAll("[data-tab='menu'] [data-item]")
  const tabConteudo = document.querySelectorAll("[data-tab='conteudo']")

  if((tabBotao.length > 0 && tabBotao != null) && (tabConteudo.length > 0 && tabConteudo != null))
  {
    tabConteudo[0].classList.add("ativo")
    tabBotao[0].classList.add("ativo")
    const mostrarTabConteudo = (item,index) => {
      tabConteudo.forEach(i => i.classList.remove("ativo"))
      tabBotao.forEach(i => i.classList.remove("ativo"))
      
      tabConteudo[index].classList.add("ativo")
      item.classList.add("ativo")
      
    }
      tabBotao.forEach((item, index) => {
        item.addEventListener("click", ()=>{
            mostrarTabConteudo(item,index)
        })
      })
  }
  
}

export default initTabMenu